// import React from "react";
// import { Box, Snackbar, Typography, IconButton } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import Error from "../../assets/Error.png";
// import CheckCircle from "../../assets/CheckCircle.png";

// const ReusableSnackbar = ({
//     open,
//     onClose,
//     message,
//     autoHideDuration = 2000,
// }) => {
//     const isSuccess = message?.toLowerCase().includes("successfully");
//     const isError =
//         message?.toLowerCase().includes("error") ||
//         message?.toLowerCase().includes("failed") ||
//         message?.toLowerCase().includes("already scanned") ||
//         // message?.toLowerCase().includes("already added") ||
//         message?.toLowerCase().includes("not scanning") ||
//         message?.toLowerCase().includes("Please select") ||
//         message?.toLowerCase().includes("stop") ||
//         message?.toLowerCase().includes("no") ||
//         message?.toLowerCase().includes("scanned code not found in system");



//     return (
//         <>
//             {open && (
//                 <Box
//                     sx={{
//                         position: "fixed",
//                         top: 0,
//                         left: 0,
//                         width: "100vw",
//                         height: "100vh",
//                         backgroundColor: "rgba(0, 0, 0, 0.4)",
//                         zIndex: 1300,
//                         cursor: "pointer",
//                     }}
//                 />
//             )}
//             <Snackbar
//                 open={open}
//                 autoHideDuration={autoHideDuration}
//                 onClose={onClose}
//                 sx={{
//                     justifyContent: "center",
//                     alignItems: "center",
//                     display: "flex",
//                     width: "100%",
//                     height: "100%",
//                     position: "fixed",
//                     top: 0,
//                     left: 0,
//                     zIndex: 1400,
//                 }}
//                 ContentProps={{
//                     sx: {
//                         backgroundColor: "transparent",
//                         boxShadow: "none",
//                         padding: 0,
//                         justifyContent: "center",
//                         alignItems: "center",
//                     },
//                 }}
//             >
//                 <Box
//                     sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         flexDirection: "column",
//                         backgroundColor: "#fff",
//                         borderBottom: isSuccess
//                             ? "2px solid green"
//                             : isError
//                                 ? "2px solid red"
//                                 : "2px solid grey",
//                         borderRadius: "8px",
//                         padding: "16px",
//                         boxShadow: "0px 2px 10px rgba(0,0,0,0.2)",
//                         minWidth: "350px",
//                         height: "250px",
//                         justifyContent: "center",
//                         textAlign: "center",
//                         position: "relative",
//                     }}
//                 >
//                     <IconButton
//                         onClick={onClose}
//                         sx={{
//                             position: "absolute",
//                             top: 8,
//                             right: 8,
//                             color: "#000",
//                         }}
//                     >
//                         <CloseIcon fontSize="small" />
//                     </IconButton>
//                     {isSuccess && <img src={CheckCircle} alt="Success" style={{ width: 80, marginBottom: 16 }} />}
//                     {isError && <img src={Error} alt="Error" style={{ width: 100, marginBottom: 20 }} />}
//                     <Typography variant="h6" fontWeight="bold" gutterBottom>
//                         {isSuccess ? "Successfull!" : "Oops!"}
//                     </Typography>
//                     <Typography variant="body1">{message}</Typography>
//                 </Box>
//             </Snackbar>
//         </>
//     );
// };

// export default ReusableSnackbar;

import React from "react";

const ReusableSnackbar = () => {
    return null;
};

export default ReusableSnackbar;